import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@tanium/react-box';
import { Stack } from '@tanium/react-stack';
import { ThemeColors } from '@tanium/theme-data';
import TaniumLogo from '../../static/tanium_logo.svg';

export const TaniumLoginCard: React.FC = ({ children }) => {
  const { t } = useTranslation();
  return (
    <Box as={Stack} fill borderRadius="8px" minHeight="400px" width="800px" boxShadow="Overlay2">
      <Box borderLeftRadius="8px" bg={'#1A2533'} height="100%" display="flex" alignItems="center">
        <img src={TaniumLogo} alt={t('Tanium logo')} height="60px" width="100%" />
      </Box>
      <Box
        borderRightRadius="8px"
        bg={ThemeColors.FillLevel2}
        height="100%"
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
        fontSize="14px"
      >
        <Box width="280px" py={2} height="100%" display="flex" justifyContent="center" flexDirection="column">
          {children}
        </Box>
      </Box>
    </Box>
  );
};
